/**
 * @description helper functions for mediaLibrary
 * @author Pranav Ramachandran
 */

// TODO re write using some algorithm (iff performace issue piles up)
export function findNode(id, treeData) {
    for (const node of treeData) {
        if (node.key == id) {
            return node;
        } else {
            if (node.children && node.children.length) {
                let data = findNode(id, node.children);
                if (data) {
                    return data;
                }
            }
        }
    }
}
// Lookup find. To find already loaded node
export function findNodeByLookup(lookup, id) {
    return lookup.get(Number(id));
}

export function clearLoadedKeys(childs, keysToRemove, loadedKeyList) {
    childs.forEach((child) => {
        if (loadedKeyList.includes(String(child.key))) {
            keysToRemove.push(String(child.key));
        }
        if (child.children) {
            clearLoadedKeys(child.children, keysToRemove, loadedKeyList)
        }
    });
}

// create new node lookup (node id => value)
export function buildLookup(treeData, map = new Map()) {
    treeData.forEach(node => {
        map.set(node.key, node);
        if (node.children) {
            buildLookup(node.children, map)
        }
    });
    return map;
}